import {type ApiFetch, apiEndpoint} from "@/components/Providers/JWTProvider.tsx";

export const doGetApprovalRoutes = async (apiFetch: ApiFetch) => {
    const url = new URL("/v1/instructor/approval-routes", apiEndpoint);
    const response = await apiFetch(url.toString());
    return await response.json();
};
